<template>
  <div class="floating-component">
    <!-- 悬浮内容 -->
    <el-tooltip placement="left" effect="light" popper-class="too">
      <div slot="content">
<!--        @click="handleQues"-->
        <el-button icon="el-icon-s-comment" class="butto" >技术热线：0471-3337110</el-button><br/>
<!--        <el-button icon="el-icon-question" class="butto" @click="handleHelp(dict.type.help_url[0].value)">帮助手册 </el-button>-->
      </div>
      <el-button icon="el-icon-menu" circle class="but"></el-button>
    </el-tooltip>

<!--    <ques-dialog ref="quesDialog"></ques-dialog>-->
  </div>
</template>

<script>
// import QuesDialog from "@/views/system/question/quesDialog";

export default {
  name: "FloatBar",
  // dicts: ['help_url'],
  components: {
    // QuesDialog,
  },
  methods: {
    handleQues() {
      let params = {
        update: true,
        check: false,
        title: '添加意见和建议',
        form: {},
      }
      this.$refs.quesDialog.handleOpen(params);
    },
    handleHelp(val) {
      // window.location.href = 'https://www.baidu.com';
      window.open(val);
    },
  },
}
</script>

<style scoped>
.floating-component {
  position: fixed;
  /*bottom: 5%;*/
  bottom: 4.5%;
  /*right: 1%;*/
  right: 5%;
  /*background-color: rgba(0, 0, 0, 0.5);*/
  /*color: rgba(255,255,255,0.3);*/
  padding: 0;
  border-radius: 50%;
  z-index: 10000; /* 设置 z-index 确保悬浮在顶层 */
}
.but {
  font-size: 15px;
  /*font-size: larger;*/
  color: rgb(0,119,216);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}
.butto {
  border: 0;
  padding: 10px;
  margin: 0;
}
</style>

<style>
.too.el-tooltip__popper.is-light {
  border: none !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  padding: 5px
}
/* 修改箭头边框 这里方位是right，所以 x-placement^="left" 并且是设置 border-right-color 的颜色*/
.too.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow {
  border-left-color: #eaeaea !important;
}
.too.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #eaeaea !important;
}
</style>
